import { Radio } from '@headlessui/react';

import Props from '@/components/@base/input/radio/option/type';

export default function RadioOption({ children, value = '', ...props }: Props) {
  return (
    <Radio value={value} {...props}>
      {children}
    </Radio>
  );
}
